@if (WEATHER_WIDGET) {
  <div class="weather-forecast">
    <app-weather-widget></app-weather-widget>
  </div>
}

@if (LOCATION_WIDGET) {
  <div class="map-container">
    <iframe
      [src]="LOCATION_URL"
      width="100%"
      height="25%"
      style="border: 0; border-radius: 12px"
      allowfullscreen=""
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
}
